import type { VariantProps } from 'tailwind-variants'
import { button_recipe } from './button.svelte.recipe'

export type LinkButtonVariant = VariantProps<typeof link_button_recipe>

export const link_button_recipe = button_recipe
